export interface OtpInputFormValues {
  code: string
}

export const OTP_INPUT_LENGTH = 6
